/* MPF store behaviours: the Products mega panel and the one-product landing gallery. */
(function () {
  if (!customElements.get('mpf-mega')) {
    customElements.define('mpf-mega', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details.querySelector('summary');
        this.cats = Array.from(this.querySelectorAll('[data-mpf-cat]'));
        this.details_ = Array.from(this.querySelectorAll('[data-mpf-detail]'));
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        let closeTimer;
        const open = () => { clearTimeout(closeTimer); this.details.open = true; };
        const close = () => { closeTimer = setTimeout(() => { this.details.open = false; }, 180); };
        if (fine.matches) {
          this.addEventListener('mouseenter', open);
          this.addEventListener('mouseleave', close);
        }
        this.cats.forEach((a) => {
          const show = () => this.show(a.dataset.mpfCat);
          a.addEventListener('mouseenter', show);
          a.addEventListener('focus', show);
        });
        document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.details.open) { this.details.open = false; this.summary.focus(); } });
        document.addEventListener('click', (e) => { if (this.details.open && !this.contains(e.target)) this.details.open = false; });
      }
      show(n) {
        this.cats.forEach((c) => c.classList.toggle('is-active', c.dataset.mpfCat === n));
        this.details_.forEach((d) => d.classList.toggle('is-active', d.dataset.mpfDetail === n));
      }
    });
  }

  // Collection showcase: one product at a time, crossfading; arrows, dots with a progress bar, swipe.
  // Stops while hovered or focused, and does not turn by itself when reduced motion is set.
  if (!customElements.get('mpf-showcase')) {
    customElements.define('mpf-showcase', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.mpf-case__slide'));
        this.dots = Array.from(this.querySelectorAll('.mpf-case__dots button'));
        if (this.slides.length < 2) return;
        this.i = 0;
        this.ms = +this.dataset.interval || 5000;
        this.style.setProperty('--mpf-case-ms', this.ms + 'ms');
        this.still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('.mpf-case__btn').forEach((b) => b.addEventListener('click', () => this.go(this.i + +b.dataset.dir, true)));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.go, true)));
        const hold = () => { this.paused = true; this.classList.add('is-paused'); clearTimeout(this.t); };
        const free = () => { this.paused = false; this.classList.remove('is-paused'); this.arm(); };
        this.addEventListener('mouseenter', hold); this.addEventListener('mouseleave', free);
        this.addEventListener('focusin', hold); this.addEventListener('focusout', free);
        let x0 = null;
        this.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        this.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) { this._swiped = true; setTimeout(() => { this._swiped = false; }, 60); this.go(this.i + (dx < 0 ? 1 : -1), true); } });
        this.slides.forEach((s) => s.addEventListener('click', (e) => { if (this._swiped) e.preventDefault(); }));
        this.go(0);
      }
      go(n, user) {
        const k = this.slides.length;
        this.i = ((n % k) + k) % k;
        this.slides.forEach((s, j) => { const on = j === this.i; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', String(!on)); s.tabIndex = on ? 0 : -1; });
        this.dots.forEach((d, j) => { d.setAttribute('aria-selected', String(j === this.i)); d.classList.remove('is-run'); });
        const d = this.dots[this.i]; if (d) { void d.offsetWidth; d.classList.add('is-run'); }
        if (user) this.classList.add('is-user');
        this.arm();
      }
      arm() {
        clearTimeout(this.t);
        if (this.still || this.paused) return;
        this.t = setTimeout(() => this.go(this.i + 1), this.ms);
      }
      disconnectedCallback() { clearTimeout(this.t); }
    });
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('.mpf-thumb');
    if (!t) return;
    const gallery = t.closest('.mpf-single__gallery');
    const img = gallery && gallery.querySelector('.mpf-single__main img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = t.dataset.mpfSrc;
    gallery.querySelectorAll('.mpf-thumb').forEach((b) => b.classList.toggle('is-active', b === t));
  });
})();
